import { useEffect, useState } from "react";

const computeElapsed = (startedAt: number | null) =>
  startedAt === null
    ? 0
    : Math.max(0, Math.floor((Date.now() - startedAt) / 1000));

/**
 * Seconds elapsed since `startedAt` (epoch ms), ticking once per second.
 * Derived from the timestamp rather than an incrementing counter so StrictMode
 * double-mounts and background-tab timer throttling cannot drift it.
 */
export function useElapsedSeconds(startedAt: number | null): number {
  const [elapsed, setElapsed] = useState(() => computeElapsed(startedAt));

  useEffect(() => {
    setElapsed(computeElapsed(startedAt));
    if (startedAt === null) return;
    const interval = setInterval(() => {
      setElapsed(computeElapsed(startedAt));
    }, 1000);
    return () => clearInterval(interval);
  }, [startedAt]);

  return elapsed;
}
